'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconOutwardSquaresThree, iconOutwardSquaresThreeTag } from '@ni/nimble-components/dist/esm/icons/outward-squares-three';
import { wrap } from '../../utilities/react-wrapper';

export type { IconOutwardSquaresThree };
export { iconOutwardSquaresThreeTag };
export const NimbleIconOutwardSquaresThree = wrap(IconOutwardSquaresThree);